// Module dependencies
import BrowserType from 'app/packages/browser';
import CONST from 'app/common/lib/Const';
import context from 'app/common/lib/context';

/**
 * Detect browser type from user agent string.
 */
const BrowserDetector = {
  getBrowser() {
    const browserName = context.instance.browser_name || '';
    switch (true) {
      case browserName.includes('Chrome'):
        return CONST.BrowserType.CHROME;
      case browserName.includes('Safari'):
        return CONST.BrowserType.SAFARI;
      case browserName.includes('Firefox'):
        return CONST.BrowserType.FIREFOX;
      case browserName.includes('Opera'):
        return CONST.BrowserType.OPERA;
      case browserName.includes('IE'):
        return CONST.BrowserType.IE;
      default:
        return CONST.BrowserType.OTHER;
    }
  },

  getBrowserName() {
    const browser = BrowserDetector.getBrowser();
    return (
      Object.keys(BrowserType).find((name) => BrowserType[name] === browser) || ''
    ).toLowerCase();
  },

  isSafari() {
    return this.getBrowser() === CONST.BrowserType.SAFARI;
  },
};

export default BrowserDetector;
